export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4644.4a941cae.jpg";